export default {"src":"/_next/static/media/wallet-message.d6517afd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};